import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";


const API_BASE = process.env.REACT_APP_API_BASE;



// Thunk to fetch current referral reward config
export const fetchReferralReward = createAsyncThunk(
  "referralRewards/fetchCurrent",
  async (_, thunkAPI) => {
    try {
      const res = await fetch(`${API_BASE}/api/invite-referral-rewards/current`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      const json = await res.json();

      if (!res.ok) {
        return thunkAPI.rejectWithValue(json?.message || "Failed to fetch reward");
      }

      return json.data; // <- API wraps the reward config in data
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message || "Network error");
    }
  }
);

const referralRewardsSlice = createSlice({
  name: "referralRewards",
  initialState: {
    rewardAmount: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReferralReward.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReferralReward.fulfilled, (state, action) => {
        state.loading = false;
        state.rewardAmount = action.payload?.reward_amount || 0;
      })
      .addCase(fetchReferralReward.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default referralRewardsSlice.reducer;
